import React from 'react';

export default () => {
  return <div>구매 관리</div>;
};
